import { Deserializable } from '../protocols/deserializable';
import { AnnuityPayeeDesignationEnum } from '../transactions/enum/annuity-payee-designation.enum';
import { AnnuityPensionAccountPaymentInstructionStatusEnum } from '../transactions/enum/annuity-pension-account-payment-instruction-status.enum';

export class PaymentMethodAnnuityUsage implements Deserializable {
  public accountId: number | null = null;
  public payeeDesignationId: AnnuityPayeeDesignationEnum | null = null;
  public annuitantName: string | null = null;
  public paymentInstructionStatusId!: AnnuityPensionAccountPaymentInstructionStatusEnum;

  onDeserialize(): void {}
}
